export default "__VITE_ASSET__DunjkIRy__"